<h2 mat-dialog-title class="font-weight-bolder add-data-title">Add Data</h2>
<mat-dialog-content>
  <app-loading [show]="isLoading" label="Loading data..."></app-loading>
  <mat-label #lblError id="lblError" class="error"></mat-label>
  <div *ngIf="!isLoading && !error" class="upload-layer-container" [formGroup]="newLayerForm">
    <mat-label class="p-2">Enter a name for the XYZ Layer.</mat-label>
    <mat-form-field class="form-slim w-100 mt-1">
      <input matInput placeholder="New Layer Name" formControlName="newXYZLayerName" id="newXYZLayerName" type="text" maxlength="18" />
    </mat-form-field>
    <div class="d-flex align-items-center g-1 mt-1">
      <span>Opacity:</span>
      <mat-slider class="flex-grow-1" min="0" max="100" step="1" [displayWith]="formatPercentLabel">
        <input matSliderThumb formControlName="newXYZLayerOpacity">
      </mat-slider>
    </div>
  </div>
</mat-dialog-content>
<mat-dialog-actions>
  <button matButton="elevated" [mat-dialog-close]="false">Back</button>
  <button matButton="filled" color="primary"  id="btnAdd" [mat-dialog-close]="true" (click)="addXYZLayer()">Add</button>
</mat-dialog-actions>
